import { TriangleAlert } from "lucide-react";
import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { Link, palette } from "@powerdiary/components-library/lib";
import { useEffect } from "react";

export default function SomethingWentWrong() {
    const theme = useTheme();

    useEffect(() => {
        document.title = "Error - Client Bookings Zanda";
    }, []);

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            p={2}
            data-test-id="section_something_went_wrong"
        >
            <Paper elevation={4} sx={{ width: "600px" }}>
                <Stack spacing={3} p={4} alignItems="center">
                    <TriangleAlert
                        size={28}
                        strokeWidth={2}
                        color={theme.palette.primary.main}
                        data-test-id="icon_error"
                        aria-hidden
                    />
                    <Box display="flex" flexDirection="column" gap={1}>
                        <Typography variant="heading3" textAlign="center" data-test-id="text_error_title">
                            Something went wrong
                        </Typography>
                        <Typography
                            variant="paragraphMediumRegular"
                            textAlign="center"
                            data-test-id="text_error_subtitle"
                        >
                            We are sorry and working on getting this fixed as soon as we can.
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            background: palette.neutral[50],
                            borderRadius: 1,
                            padding: 2,
                        }}
                        data-test-id="section_error_instructions"
                    >
                        <Typography variant="paragraphMediumBold" data-test-id="text_instructions_title">
                            What can you do?
                        </Typography>
                        <ul style={{ margin: 0 }}>
                            <li>
                                <Typography variant="paragraphMediumRegular" data-test-id="text_instruction_reload">
                                    Please try{" "}
                                    <Link
                                        variant="paragraphMediumBold"
                                        onClick={() => window.location.reload()}
                                        data-test-id="link_reload"
                                    >
                                        reloading
                                    </Link>{" "}
                                    the page.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="paragraphMediumRegular" data-test-id="text_instruction_contact">
                                    If you&apos;re still having trouble, contact your practice directly for help.
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                </Stack>
            </Paper>
        </Box>
    );
}
